import { ActionIcon, Center, Checkbox, Group, Table, Text, Tooltip } from '@mantine/core';
import { openConfirmModal } from '@mantine/modals';
import { IconPencil, IconTrashX } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { DictionaryItem } from '@mygpt/app';

interface DictionaryItemProps {
  item: DictionaryItem;
  selected?: boolean;
  score?: number;
  onSelectedChange?: (selected: boolean) => void;
  onDelete: (item: DictionaryItem) => void;
  onEdit: (item: DictionaryItem) => void;
}
export const Item = ({ item, onDelete, onEdit, onSelectedChange, selected }: DictionaryItemProps) => {
  const { t } = useTranslation();

  const deleteFileConfirm = (item: DictionaryItem) => {
    openConfirmModal({
      title: t('faqs.delete.title'),
      centered: true,
      children: <span dangerouslySetInnerHTML={{ __html: t('faqs.delete.confirm') }} />,
      labels: { confirm: t('delete_btn'), cancel: t('alert_cancel') },
      onCancel: () => console.log('Cancel'),
      confirmProps: {
        color: 'red',
        onClick: () => onDelete(item),
      },
    });
  };

  return (
    <Table.Tr>
      <Table.Td className="break-words" style={{ wordBreak: 'break-word' }}>
        <Group gap="xs" wrap="nowrap">
          <Checkbox checked={selected} onChange={() => onSelectedChange?.(!selected)} />
          <Text>{item.source}</Text>
        </Group>
      </Table.Td>
      <Table.Td className="break-words" style={{ wordBreak: 'break-word' }}>
        {item.target}
      </Table.Td>
      <Table.Td>
        <Text size="sm" c="gray.4">
          {dayjs(item.updated_at).format('YYYY-MM-DD HH:mm:ss')}
        </Text>
      </Table.Td>
      <Table.Td>
        <Center>
          <Tooltip label={t('edit')}>
            <ActionIcon variant="subtle" onClick={() => onEdit(item)} size="sm">
              <IconPencil size={14} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label={t('delete_btn')}>
            <ActionIcon variant="subtle" onClick={() => deleteFileConfirm(item)} size="sm">
              <IconTrashX color="red" size={14} />
            </ActionIcon>
          </Tooltip>
        </Center>
      </Table.Td>
    </Table.Tr>
  );
};
